import { Platform } from 'react-native';

// Dimensions
export const nano = 1;
export const micro = 2;
export const mini = 4;
export const xsmall = 6;
export const small = 8;
export const medium = 10;
export const large = 12;
export const xlarge = 14;
export const xxlarge = 16;
export const xxxlarge = 18;

// Colors
// Basics

export const black = '#000000';
export const white = '#fff';
export const offwhite = '#eee';
export const lightGrey = '#ececec';
export const grey = '#B8B8B8';
export const blurGrey = '#898484';
export const iconGrey = '#404040';
export const labelGray = '#808080';
export const disabledText = '#555555';
export const darkestGrey = '#1F1F1F';
export const darkGrey = '#262626';
export const red = '#ee0e0e';
export const green = '#1DB954';
export const lightGreen = '#59c21e';
export const purple = '#6d02e3';
export const lightPurple = '#865BD9'; // In Mocks but it might be too light
export const darkPurple = '#460191';
export const lightBlue = '#33C4FF';
export const orange = '#ffa500';

// export const orange = '#F4AC74';
// export const darkPurple = '#6d02e3';
// export const purple = '#986ACB'; // In Mocks but it might be too light
// export const purple = '#6d02e3';
// export const darkPurple = '#460191';
export const tintColorLight = darkPurple;
export const tintColorDark = white;
export const separatorDarkColor = 'rgba(255,255,255,0.1)';
export const separatorLightColor = offwhite;
// Typography
export const bold = 'bold';
export const italic = 'italic';
export const main = 'arial';
export const sub = 'Arial Black';
export const fontFamily = 'space-mono';
export const fontFamilyRegular = 'gg-regular';
export const fontFamilyBold = 'gg-bold';
export const fontFamilySemiBold = 'gg-semibold';
export const fontFamilyLight = 'gg-alt-light';
export const fontFamilyMedium = 'gg-medium';

//  FONT SIZES
export const fontSizeSmall = 16;
export const fontSizeExtraSmall = 14;
export const fontSizeMicro = 10;
export const fontSizeMedium = 18;
export const fontSizeMediumLarge = 24;
export const fontSizeLarge = 32;

// WIDTHS
export const defaultWidth = Platform.OS === 'web' ? 275 : '80%';

// BUTTONS
export const disabledBackgroundColor = grey;
export const buttonBackground = purple;
export const buttonBackgroundHover = darkPurple;

export const buttonTextHover = white;
export const buttonBorderRadius = 12;
export const buttonPadding = 10;
export const buttonOutlined = {
  borderColor: buttonBackground,
  borderWidth: 1,
  borderRadius: buttonBorderRadius,
};
export const buttonOutlinedHover = {
  borderColor: buttonBackground,
  borderWidth: 1,
  borderRadius: buttonBorderRadius,
  backgroundColor: buttonBackgroundHover,
};
export const outlinedButtonTextHoverColor = white;
export const outlinedButtonTextColor = buttonBackground;
export const minButtonWidth = 120;

export const optionSelectedBackgroundColor = orange;
export const paddingSmall = 12;
export const paddingMedium = 24;

// INPUTS
export const textInputBorderRadius = 12;
export const textInputBackgroundColor = darkestGrey;
export const textInputBorderStyle = 'solid';
export const textInputBorderWidth = 1;
export const textInputPadding = 9;
export const textInputLabelPadding = 5;
export const textInputPlaceholderColor = black;
export const errorRed = red;
export const inputBlurGrey = blurGrey;
export const focusGreen = lightGreen;
export const focusBlue = lightBlue;
export const transparent = 'transparent';
export const textInputHeight = 42;

export const linkColor = white;
export const editLinkColor = purple;

// export const secondary = '#ffc7ab';
// export const secondaryLight = '#f5e9a0';
// export const secondaryLighter = '#b552e2';
// export const secondaryDark = '#ff6777';
// export const secondaryDarker = '#6154ae';

export const iosSwitchBackgroundColor = iconGrey;
export const switchThumbOn = purple;
export const switchThumbOff = lightGrey;
export const switchThumbOffAlt = lightPurple;
export const switchTrackOn = lightPurple;
export const switchTrackOff = iconGrey;
export const borderRadius = 12;
